<template>
  <div class="content content--profile">
    <MyHeader />

    <header class="content-header">
      <h1>Profile</h1>
    </header>

    <div class="tabs">
      <div class="tabs-inner">
        <router-link v-if="displayProfileEdit" :to="{name: 'ProfileEdit'}" exact active-class="active">Edit</router-link>
<!--        <router-link :to="{name: 'ProfileAwards'}" exact active-class="active">Awards</router-link>-->
        <router-link :to="{name: 'ProfileIdeas'}" exact active-class="active">My ideas</router-link>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import MyHeader from '../../components/general/Header'
import settings from "@/settings";
export default {
  name: "Profile",
  components: { MyHeader },
  computed: {
    displayProfileEdit() {
      return this.$store.getters.settingsCompanyFlagByCode(settings.SETTING_TYPES_FLAGS.SHOW_PROFILE_EDIT)
      // return true;
    }
  },
  mounted() {
    window._paq.push(['setDocumentTitle', 'Profile']);
    window._paq.push(['trackPageView']);
  }
}
</script>

<style scoped>

</style>
